const subHeadlineElements = ["h2", "h3", "h4", "h5", "h6", "p", "a", "span"];
const textElements = ["div", "p", "span", "strong"];
const allowed = {
  actions: {
    allowedElements: ["div", "a", "button", "umd-element-call-to-action"]
  },
  body: {
    deprecated: 'Use "text" instead. This attribute will be removed in version 2.0.',
    allowedElements: [...textElements]
  },
  content: {
    allowedElements: ["div"]
  },
  eyebrow: {
    allowedElements: ["span", "p"]
  },
  headline: {
    allowedElements: ["h1", ...subHeadlineElements]
  },
  image: {
    allowedElements: ["img"]
  },
  images: {
    allowedElements: ["div"]
  },
  imageLink: {
    allowedElements: ["img", "a"]
  },
  subHeadline: {
    allowedElements: subHeadlineElements
  },
  text: {
    allowedElements: [...textElements]
  },
  time: {
    allowedElements: ["time"]
  }
};
export {
  allowed
};
//# sourceMappingURL=element.js.map
